import React, { Component } from "react";
import { css } from "aphrodite/no-important";
import { styles } from "./AccountStyles";
import { connect } from "react-redux";
import PopupWrapper from "../components/PopupWrapper";
import Spacer from "../components/Spacer";
import { Redirect } from "react-router";
import AccountSubheader from "../components/AccountSubheader";
import { Field, reduxForm, SubmissionError } from "redux-form";
import {
  passwordActions,
  popupActions,
  accountHomeViewActions,
} from "../_actions";
import { withCookies } from "react-cookie";
import AccountBackButton from "../components/AccountBackButton";

const renderRadio = (props) => {
  const {
    meta: { touched, error, warning },
  } = props;
  return (
    <span>
      <div className={css(styles.checkboxWrapper)}>
        <div className={css([styles.radio])}>
          <span
            className={css([
              styles.radioIcon,
              props.input.checked && styles.radioIconChecked,
            ])}
          />
        </div>
        <strong className={css([styles.label, styles.radioLabel])}>
          {props.label}
        </strong>
      </div>
      <input
        className={css(styles.hidden)}
        {...props.input}
        type={props.type}
      />
      {touched &&
        ((error && <span className={css(styles.error)}>{error}</span>) ||
          (warning && <span>{warning}</span>))}
    </span>
  );
};

class AccountHomeViewTariffEditTime extends Component {
  constructor(props) {
    super(props);
    this.state = {
      redirect: null,
      time: props.match.params.time,
      rate: props.match.params.rate,
      level: props.match.params.level,
    };

    const user = JSON.parse(localStorage.getItem("user"));
    const level = props.match.params.level;
    if (level == "infocare") {
      user.user_id = user.dependant_user_id;
    }

    this.props.dispatch(accountHomeViewActions.getTariff(user));
  }

  submit = (values) => {
    this.setState({
      redirect: `/account/${this.state.level}/tariff/edit-rates/${values.rates}/${this.state.rate}`,
    });
  };
  capitaliseFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
  render() {
    const { handleSubmit, pristine, submitting } = this.props;

    if (this.state.redirect) {
      return <Redirect to={this.state.redirect} />;
    }

    return (
      <div className={css(styles.container)}>
        <PopupWrapper />

        <header className={css(styles.header)}>
          <div className={css(styles.titleWrapper)}>
            <img
              src={"/icons/AccountIconLarge.svg"}
              className={css(styles.accountIcon)}
              alt=""
            />
            <h1 className={css(styles.title)}>Account</h1>
          </div>
          <AccountBackButton />
        </header>
        <main className={css(styles.mainContainer)}>
          <AccountSubheader
            backLabel="Tariff"
            backHref={`/account/${this.state.level}/tariff/`}
            title={`${this.capitaliseFirstLetter(this.state.rate)} Rates`}
          />
          <h2 className={css(styles.label)}>When do these rates apply?</h2>
          <form onSubmit={handleSubmit(this.submit)}>
            <Spacer />
            <div>
              <label>
                <Field
                  name="rates"
                  component={renderRadio}
                  type="radio"
                  value="weekdays"
                  label={"Weekdays only"}
                />
              </label>
            </div>
            <div>
              <label>
                <Field
                  name="rates"
                  component={renderRadio}
                  type="radio"
                  value="weekend"
                  label={"Weekends only"}
                />
              </label>
            </div>
            <div>
              <label>
                <Field
                  name="rates"
                  component={renderRadio}
                  type="radio"
                  value="all"
                  label={"Every day"}
                />
              </label>
            </div>
            <Spacer />
            <Spacer />
            <button
              type="submit"
              disabled={submitting}
              className={css(styles.buttonGreen)}
            >
              Go to Rates
            </button>
          </form>
        </main>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  const initialValues = {
    rates: props.match.params.time,
  };
  return {
    initialValues,
    ...state,
  };
};

export default connect(mapStateToProps)(
  reduxForm({
    form: "accountHomeViewTariffEditTime",
    destroyOnUnmount: false,
    enableReinitialize: true,
  })(withCookies(AccountHomeViewTariffEditTime))
);
